var map = {
	"./Foraminifera_center_001.jpg": 2053,
	"./Globigerina_000.jpg": 1969,
	"./Globigerina_001.jpg": 2354,
	"./Globigerina_003.jpg": 8070,
	"./Globigerinas.jpg": 5085,
	"./Radiolaria_03.jpg": 3933,
	"./Radiolaria_05 (1).jpg": 7226,
	"./Radiolaria_05 (3).jpg": 2244,
	"./Radiolaria_05 (5).jpg": 1798,
	"./Radiolarians_004.jpg": 9115,
	"./radiolarians_001.jpg": 8811,
	"./radiolarians_002.jpg": 559,
	"./radiolarians_003.jpg": 9611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2788;